module.exports = __webpack_public_path__ + "img/expert-3.099f0d67.png";